import { AccountCircle, InfoOutlined, Login, Logout, Person } from '@mui/icons-material';
import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from '../../../auth';

export const Account: FC = () => {
    const { t } = useTranslation();
    const { documentationLink } = window.carity.environment;
    const navigate = useNavigate();

    const { data } = useGetUser();
    const user = data?.data;

    const [anchorEl, setAnchorEl] = useState<HTMLElement>();

    const onLogOut = useCallback(() => {
        window.location.href = '/auth/logout';
    }, []);

    const onLogIn = useCallback(() => {
        navigate('?login=true');
    }, [navigate]);

    const documentation = documentationLink && (
        <MenuItem key="documentation" onClick={() => window.open(documentationLink, '_blank', 'noopener,noreferrer')}>
            <ListItemIcon>
                <InfoOutlined />
            </ListItemIcon>
            {t('documentation')}
        </MenuItem>
    );

    return (
        <>
            <IconButton
                size="large"
                edge="end"
                color="inherit"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ borderRadius: 0 }}
            >
                <AccountCircle />
                <Typography sx={{ mx: 1, display: { xs: 'none', xl: 'block' } }}>
                    {user?.firstName} {user?.lastName}
                </Typography>
            </IconButton>

            <Menu
                sx={{ mt: 5 }}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(undefined)}
            >
                {user
                    ? [
                          <MenuItem key="person" disabled sx={{ '&.Mui-disabled': { opacity: 1, color: 'inherit' } }}>
                              <ListItemIcon>
                                  <Person />
                              </ListItemIcon>
                              {user?.firstName} {user?.lastName}
                          </MenuItem>,
                          documentation,
                          <MenuItem onClick={onLogOut} key="logout">
                              <ListItemIcon>
                                  <Logout />
                              </ListItemIcon>
                              {t('logOut')}
                          </MenuItem>,
                      ]
                    : [
                          documentation,
                          <MenuItem onClick={onLogIn}>
                              <ListItemIcon>
                                  <Login />
                              </ListItemIcon>
                              {t('logIn')}
                          </MenuItem>,
                      ]}
            </Menu>
        </>
    );
};
